import * as amplitude from '@amplitude/analytics-browser';

export const AMPLITUDE_API_KEY = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY;

class Analytics {
  private platform: string = 'web'
  init() {
    if (typeof window !== 'undefined' && AMPLITUDE_API_KEY) {
      amplitude.init(AMPLITUDE_API_KEY);
    }
  }

  setPlatform(platform: string) {
    this.platform = platform
  }

  trackEvent(eventName: string, eventProperties?: Record<string, any>) {
    if (typeof window !== 'undefined') {
      amplitude.track(eventName, {...eventProperties, platform: this.platform});
    }
  }

  setUserProps(props: Record<string, any>) {
    if (typeof window !== 'undefined') {
      const identify = new amplitude.Identify();

      Object.entries(props).forEach(([key, value]) => {
        identify.set(key, value); 
      });

      amplitude.identify(identify);
    }
  }

  PromoEventClick(courseName: string, slidePosition: number) {
    this.trackEvent('PromoEventClick', {
      course_name: courseName,
      slide_position: slidePosition,
    });
  }
}

export const AnalyticsService = new Analytics();